__turbopack_context__.v({
  "description": "styles-module-scss-module__ZWoo3q__description",
});
